import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { Constants } from "../Services/Constants";
import { HTTPService } from "../Services/http.service";
import { Observable } from "rxjs/Observable";
import { filter } from "../App/search.pipe";
import { DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { MySharedService } from "../App/shared.service";
declare function ExportToExcel(
  item: any[],
  workSheetName: string,
  keys: any,
  Columns?: any
): void;
declare function testrun(): void;
var selectedAssetTab = new Array();

@Component({
  selector: "IRAsset",
  templateUrl: "./AppViews/Warranty/installationAsset.html",
})
export class InstallationAssetComponent implements OnInit {
  constants: Constants;
  userDetail: any;
  AssetList: any = [];
  assetDropdownList: any = [];
  public showLoader = false;
  addAsset: any = {};
  public isFormSubmitted: boolean = false;
  assetId: any = 0;
  //   assetStartDate: any = moment().format("DD/MM/YYYY");
  assetStartDate: any = null;
  projectId: any = 0;
  irID: any = 0;
  AssetCount: any = 0;
  public assignedAssetData: any = [];
  public isProjectScreen: boolean = false;
  public EnableData: boolean = false;
  public IsExecutive: boolean = false;
  public canEditAsset: boolean = true;
  public canRemoveAsset: boolean = true;
  startDateErr: boolean = false;
  endDateErr: boolean = false;
  invalidEndDate: boolean = false;

  @Output() reloadInstallationAdd = new EventEmitter<Object>();

  constructor(
    private _httpService: HTTPService,
    private _route: Router,
    private _sharedService: MySharedService,
    private _datepipe: DatePipe
  ) {
    this.constants = new Constants();
    this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
  }

  ngOnInit() {
    if (
      this.userDetail.RoleId == this.constants.enumUserRole.Executive ||
      this.userDetail.RoleId == this.constants.enumUserRole.Vendor
    ) {
      this.IsExecutive = true;
    } else {
      this.IsExecutive = false;
    }
  }

  gAfterViewInit() {
    $(".date").datetimepicker({
      format: "DD/MM/YYYY",
    });
  }

  ngAfterViewChecked() {
    // $('#assetmultiselect option').each(function () {
    //     $(this).html($(this).html().replace(/\s+/g, ' '));
    // });
  }

  GetAssetList() {
    this.showLoader = true;
    this._httpService
      .ajaxPost("InstallationRequest/GetAssetList", {
        IRId: this.irID,
        AssetId: this.assetId,
        ProjectId: this.projectId,
        IsProject: this.isProjectScreen,
      })
      .subscribe(
        (data) => {
          this.AssetList = data["AssetList"];
        },
        (err) => {
          console.log("GetAssetList Failed");
          this.showLoader = false;
        },
        () => {
          this.showLoader = false;
        }
      );
  }

  GetAssetListForDropdown() {
    this.showLoader = true;
    this.assetDropdownList = [];
    this._httpService
      .ajaxPost("InstallationRequest/GetAssetList", {
        IRId: 0,
        AssetId: 0,
        ProjectId: this.projectId,
        IsProject: this.isProjectScreen,
      })
      .subscribe(
        (data) => {
          this.assetDropdownList = data["AssetList"];

          setTimeout(() => {
            $("#assetmultiselect").multiselect({
              enableFiltering: false,
              includeSelectAllOption: true,
              selectAllJustVisible: false,
              numberDisplayed: 1,
              maxHeight: 200,
            });

            $("#assetmultiselect").addClass("MultiselectScroll");

            $("#assetmultiselect option").each(function () {
              if ($(this).attr("selected") == "selected") {
              }
            });
          }, 0);

          $("#assetmultiselect").change(function () {
            var selectOption = $(this).find(":selected");
            var selectedValues = new Array();
            selectedAssetTab = new Array();
            selectOption.each(function (e) {
              selectedValues.push($(this).val());
              selectedAssetTab.push($(this).val());
            });
            $("#assetmultiselect").val(selectedValues);
            $("#assignedAssetData").val(selectedValues);
            var selectPanel = $("#accordion").find(".panel.panel-default");
            selectPanel.each(function (e) {
              if (
                selectedAssetTab.includes(
                  $(this).find(".panel-collapse.collapse").attr("id")
                )
              ) {
                $(this).removeClass("hide");
                $(this).addClass("show");
              } else {
                $(this).removeClass("show");
                $(this).addClass("hide");
              }
            });
          });

          $("#assetmultiselect option").each(function () {
            $(this).html($(this).html().replace(/\s+/g, " "));
          });
        },
        (err) => {
          console.log("GetAssetList Failed");
          this.showLoader = false;
        },
        () => {
          this.showLoader = false;
        }
      );
  }

  public EditAsset(itemId) {
    let objItem: any = {};
    objItem = JSON.parse(
      JSON.stringify(this.AssetList.filter((x) => x.AssetId == itemId)[0])
    );

    this.addAsset.AssetId = objItem.AssetId;
    this.addAsset.AssetName = objItem.AssetName;
    this.addAsset.AssetType = objItem.AssetType;
    this.addAsset.Make = objItem.Make;
    this.addAsset.Suppler = objItem.Suppler;
    this.addAsset.SerialNumber = objItem.SerialNumber;
    this.addAsset.SupportVendor = objItem.SupportVendor;
    this.addAsset.ContractType = objItem.ContractType;
    this.addAsset.Coverage = objItem.Coverage;
    this.addAsset.Period = objItem.Period;
    this.addAsset.PeriodText = objItem.Period + " Year";
    this.addAsset.StartDate = objItem.StartDate;
    this.addAsset.EndDate = objItem.EndDate;
    this.addAsset.IRStatusValue = objItem.IRStatusValue;
    $("#addAsset").modal("show");
  }

  UpdateAsset(form: any) {
    if (
      this.addAsset.IRStatusValue == this.constants.IRStatus.Draft ||
      this.addAsset.IRStatusValue == this.constants.IRStatus.Assigned ||
      this.addAsset.IRStatusValue == null
    ) {
      this.startDateErr = false;
      this.endDateErr = false;

      if (this.addAsset.EndDate != "" && this.addAsset.EndDate != null) {
        if (this.addAsset.StartDate == null || this.addAsset.StartDate == "") {
          this.startDateErr = true;
        }
      }
      if (this.addAsset.StartDate != "" && this.addAsset.StartDate != null) {
        if (this.addAsset.EndDate == null || this.addAsset.EndDate == "") {
          this.endDateErr = true;
        }
      }
    } else {
      this.startDateErr = false;
      this.endDateErr = false;
      if (
        this.addAsset.StartDate == null ||
        this.addAsset.StartDate == "" ||
        this.addAsset.StartDate == "undefined"
      ) {
        this.startDateErr = true;
      }
      if (
        this.addAsset.EndDate == null ||
        this.addAsset.EndDate == "" ||
        this.addAsset.EndDate == "undefined"
      ) {
        this.endDateErr = true;
      }
    }

    this.isFormSubmitted = true;
    if (
      form.form.valid &&
      !this.startDateErr &&
      !this.endDateErr &&
      !this.invalidEndDate
    ) {
      this.showLoader = true;
      this._httpService
        .ajaxPost("InstallationRequest/AddUpdateAsset", this.addAsset)
        .subscribe(
          (data) => {
            var msg = data["Status"].Message.split("|");
            if (msg.length >= 1) {
              msg[0] = msg[0].toLowerCase();
              if (msg[0] == "success") {
                //this.getProjectList(true);
                this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                this.GetAssetList();
                $("#addAsset").modal("hide");
              } else if (msg[0] == "warning") {
                this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
              } else {
                this._sharedService.ShowMessage(this.constants.globalError);
              }
            } else {
            }
          },
          (err) => {
            this.showLoader = false;
            this._sharedService.ShowMessage(this.constants.globalError);
          },

          () => {
            this.showLoader = false;
          }
        );
    }
  }

  AddAssetForIR() {
    let myDiv = document.getElementById("assignedAssetData");
    var AssetIds = myDiv["value"];
    this.showLoader = true;
    // if (this.assetStartDate == null || this.assetStartDate == "") {
    //   this._sharedService.ShowMessage(
    //     "error|Please select Warranty Start Date for Asset."
    //   );
    //   this.showLoader = false;
    //   return;
    // }
    if (AssetIds == null || AssetIds == "") {
      this._sharedService.ShowMessage("error|Please select atleast one Asset.");
      this.showLoader = false;
      return;
    }

    this._httpService
      .ajaxPost("InstallationRequest/AddUpdateAssetsInIR", {
        AssetId: AssetIds,
        IRId: this.irID,
        StartDate: this.assetStartDate,
      })
      .subscribe(
        (data) => {
          var msg = data["Status"].Message.split("|");
          if (msg.length >= 1) {
            msg[0] = msg[0].toLowerCase();
            if (msg[0] == "success") {
              //this.getProjectList(true);
              this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
              $("#assetmultiselect").multiselect("destroy");
              this.GetAssetList();
              this.GetAssetListForDropdown();
              $("#assignedAssetData").val("");
              this.assignedAssetData = [];
              $("#addAsset").modal("hide");
              this.reloadInstallationAdd.emit();
            } else if (msg[0] == "warning") {
              this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
            } else {
              this._sharedService.ShowMessage(this.constants.globalError);
            }
          } else {
          }
        },
        (err) => {
          this.showLoader = false;
          this._sharedService.ShowMessage(this.constants.globalError);
        },

        () => {
          this.showLoader = false;
        }
      );
  }

  clearFilter() {}

  public RedirectToList() {
    let isFromInstallation = JSON.parse(
      localStorage.getItem("IsFromInstallation")
    );
    if (isFromInstallation == 1) this._route.navigate(["/installation"]);
    else
      this._route.navigate([
        "/projects",
        { projectId: this.projectId, Com: 0 },
      ]);
  }

  public RemoveAsset(itemId) {
    this.showLoader = true;
    this._httpService
      .ajaxPost("InstallationRequest/RemoveAssetFromIR", { AssetId: itemId })
      .subscribe(
        (data) => {
          var msg = data["Status"].Message.split("|");
          if (msg.length >= 1) {
            msg[0] = msg[0].toLowerCase();
            if (msg[0] == "success") {
              this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
              $("#assetmultiselect").multiselect("destroy");
              this.GetAssetList();
              this.GetAssetListForDropdown();
              $("#assignedAssetData").val("");
              this.assignedAssetData = [];
            } else if (msg[0] == "warning") {
              this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
            } else {
              this._sharedService.ShowMessage(this.constants.globalError);
            }
          } else {
          }
        },
        (err) => {
          this.showLoader = false;
          this._sharedService.ShowMessage(this.constants.globalError);
        },

        () => {
          setTimeout(() => {
            this.showLoader = false;
          }, 1000);
        }
      );
  }

  EndDateValidation() {
    let startDate;
    let endDate;
    this.invalidEndDate = false;

    if (this.addAsset.StartDate != "") {
      startDate = moment(this.addAsset.StartDate, "DD/MM/YYYY");
    }
    if (this.addAsset.EndDate != "") {
      endDate = moment(this.addAsset.EndDate, "DD/MM/YYYY");
    }
    if (this.addAsset.StartDate != "" && startDate > endDate) {
      this.invalidEndDate = true;
    }
  }

  GetEndDate() {
    if (
      this.addAsset.Period > 0 &&
      this.addAsset.StartDate != "" &&
      this.addAsset.StartDate != null &&
      this.addAsset.StartDate != "undefined"
    ) {
      this.addAsset.EndDate = moment(this.addAsset.StartDate, "DD/MM/YYYY")
        .add(this.addAsset.Period, "years")
        .format("DD/MM/YYYY");
      this.addAsset.EndDate = moment(this.addAsset.EndDate, "DD/MM/YYYY")
        .subtract(1, "day")
        .format("DD/MM/YYYY");
    }
  }

  CancelAsset() {
    this.startDateErr = false;
    this.endDateErr = false;
    this.invalidEndDate = false;
  }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/Warranty/installationAsset.component.ts
 **/